// extracted by mini-css-extract-plugin
export default {"container":"Hl-z","bubbleNav":"Il-z","graphic":"Jl-z","contact":"Kl-z"};